import styled, { css } from "styled-components";

const getFontSize = (size) => {
    switch (size) {
      case 'small':
        return '12px';
      case 'large':
        return '16px';
      default:
        return '14px';
    }
  };
  
  const getIconSize = (size) => {
    switch (size) {
      case 'small':
        return '10px';
      case 'large':
        return '14px';
      default:
        return '12px';
    }
  };
  
  export const BreadcrumbsContainer = styled.nav`
    display: flex;
    align-items: center;
    font-size: ${props => getFontSize(props.$size)};
  `;
  
  export const BreadcrumbList = styled.ol`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 0;
    margin: 0;
    list-style: none;
  `;
  
  export const BreadcrumbItem = styled.li`
    display: flex;
    align-items: center;
  
    svg {
      width: ${props => getIconSize(props.$size)};
      height: ${props => getIconSize(props.$size)};
    }
    
    &:last-child {
      font-weight: ${props => props.$isLast && !props.$activeLastBreadcrumb ? 'bold' : 'normal'};
      
      a {
        ${(props) => !props.$activeLastBreadcrumb && css`
          pointer-events: none;
          color: ${props => props.$color || 'var(--text-color-primary)'};
          text-decoration: none;
        `}
      }
    }
    cursor: pointer;
  `;
  
  export const BreadcrumbLink = styled.a`
    color: ${props => props.$color || 'var(--color-text-secondary)'};
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 4px;
    
    &:hover {
      text-decoration: underline;
    }
  `;
  
  export const Separator = styled.span`
    margin: 0 8px;
    color: ${props => props.$separatorColor || 'var(--color-text-secondary)'};
    font-size: ${props => getFontSize(props.$size)};
  `;
  
  export const IconWrapper = styled.span`
    display: flex;
    align-items: center;
    color: ${props => props.$color || 'var(--color-text-secondary)'};
    margin-right: 4px;
  
    svg {
      width: ${props => getIconSize(props.$size)};
      height: ${props => getIconSize(props.$size)};
    }
  `;